<template>
  <div class="app-frame__wrapper">
    <div v-if="loaded === false" class="app-frame__content">
      <LoadingSpinner />
      <div v-if="errorLoadingApp" class="app-frame__too-long-to-load">
        <Warning class="app-frame__warning-icon" />
        <h1>Error Loading App</h1>
        <p>{{ error }}</p>
      </div>
    </div>
    <transition name="update-available">
      <div v-if="updateAvailable" class="app-frame__content app-frame__update-available">
        <div class="content">
          <h1>Update Available!</h1>
          <ActionButton kind="secondary" @click="applyUpdate">Apply Update</ActionButton>
        </div>
      </div>
    </transition>
    <iframe
      v-if="startLoadingApp"
      ref="appFrame"
      :class="['app-frame', { 'app-frame--loaded': loaded }]"
      :src="src"
      allow="geolocation"
      referrerpolicy="origin"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import LoadingSpinner from "./icons/LoadingSpinner";
import Warning from "./icons/Warning";
import ActionButton from "./ActionButton";

import { onMessageToWebApp, onMessageFromWebApp } from "../messages/webAppMessenger";
import { ALL, APP_LOADED } from "../messages/messageTypes";
import { skipWaiting } from "../initializeServiceWorker";

export default {
  name: "AppFrame",
  components: {
    LoadingSpinner,
    ActionButton,
    Warning
  },
  data() {
    return {
      startLoadingApp: false,
      loaded: false,
      errorLoadingApp: false,
      error: null,
      siteIsAvailable: false,
      src: process.env.VUE_APP_DOMAIN + window.location.pathname + window.location.search
    };
  },
  computed: {
    ...mapState({
      updateAvailable: state => state.ui.updateAvailable
    })
  },
  created() {
    this.loadingTimeout = setTimeout(() => {
      this.errorLoadingApp = true;
      this.error =
        "We are sorry, but something is going wrong loading the app. This error has been reported and we will look into it right away.";
    }, 30000);
  },
  mounted() {
    setTimeout(() => {
      this.startLoadingApp = true;
      this.fromAppListener = onMessageFromWebApp(APP_LOADED, () => {
        this.loaded = true;
      });
      this.toAppListener = onMessageToWebApp(ALL, this.sendMessage);
    }, 10);
  },
  destroyed() {
    if (this.toAppListener) {
      this.toAppListener.unsubscribe();
    }
    if (this.fromAppListener) {
      this.fromAppListener.unsubscribe();
    }
  },
  methods: {
    applyUpdate() {
      skipWaiting();
    },
    sendMessage(message) {
      console.log("sendMessage", message);
      this.$refs.appFrame.contentWindow.postMessage(message, process.env.VUE_APP_DOMAIN);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.update-available-enter-active,
.update-available-leave-active {
  transition: all 0.3s ease;
}

.update-available-enter, .update-available-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-2em) scale(1.2);
  opacity: 0;
}

.app-frame {
  display: none;

  &--loaded {
    display: block;
    width: 100%;
    height: 100vh;
    border: 0;
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    border: 0;
    flex-direction: column;
  }

  &__update-available {
    z-index: 100;
    background: rgba(0, 0, 0, 0.7);
    color: 0;
    backdrop-filter: blur(10px);
    backface-visibility: hidden;
    perspective: 1000;
    transform: translate3d(0, 0, 0), translateZ(0);
    color: white;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    background: rgba(0, 0, 0, 0.5);
  }

  &__too-long-to-load {
    padding: 2em;
    text-align: center;
    color: white;
  }

  &__warning-icon {
    width: 150px;
    height: 150px;
  }
}
</style>
